import { render, staticRenderFns } from "./ClinicDetailPage.vue?vue&type=template&id=14ea61a4&"
import script from "./ClinicDetailPage.vue?vue&type=script&lang=js&"
export * from "./ClinicDetailPage.vue?vue&type=script&lang=js&"
import style0 from "./ClinicDetailPage.vue?vue&type=style&index=0&id=14ea61a4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports